import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../utils/cn';

interface FrameDisplayProps {
  startFrame: number | null;
  endFrame: number | null;
  onComplete?: () => void;
  className?: string;
}

const FrameDisplay: React.FC<FrameDisplayProps> = ({
  startFrame,
  endFrame,
  onComplete,
  className,
}) => {
  const frameCount = startFrame !== null && endFrame !== null
    ? endFrame - startFrame
    : null;

  const canComplete = startFrame !== null && endFrame !== null;

  return (
    <div className={cn("flex items-center justify-between p-4 bg-gray-50 rounded-lg", className)}>
      <div className="space-y-1">
        <div className="text-sm text-gray-500">フレーム情報</div>
        <div className="text-lg font-semibold">
          {frameCount !== null ? (
            <>フレーム数: {frameCount}</>
          ) : (
            <>開始・終了フレームを選択してください</>
          )}
        </div>
      </div>
      {onComplete && (
        <button
          onClick={onComplete}
          disabled={!canComplete}
          className={cn(
            "btn btn-primary space-x-2",
            !canComplete && "opacity-50 cursor-not-allowed"
          )}
        >
          <Check className="w-4 h-4" />
          <span>完了</span>
        </button>
      )}
    </div>
  );
};

export default FrameDisplay;